module.exports = __webpack_public_path__ + "img/confirm-btn-exclude.25d4d0d0.svg";